// FIXME: Migrate to `encodeURIComponent` when we can confirm it works on the backend.
// NOTE: This should be enough to escape without any other issues while keeping
// the URI strings otherwise identical. We therefore only encode the limited
// subset: that is, only punctuation characters that need to be escaped,
// `&`, `=`, and the control characters. See:
//      https://stackoverflow.com/a/31300627
const VALID_PUNCTUATION: Set<string> = new Set([
    "/",
    "?",
    ":",
    "@",
    "-",
    ".",
    "_",
    "~",
    "!",
    "$",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    ";",
]);

// NOTE: manually tested with:
//  '$abc'                               => '$abc'
//  '?$abc&x=1'                          => '?$abc%26x%3D1'
//  "?$filter=Name eq 'Jane Bond'"       => "?$filter%3DName%20eq%20'Jane%20Bond'"
//  "?$filter=startsWith(Name, 'Jane&')" => "?$filter%3DstartsWith(Name,%20'Jane%26')"
//
// You can confirm these round-trip with `decodeURIComponent`.
function encode(value: any): string {
    // NOTE: `toString()` is identical as `String(...)` except for `undefined` and `null`,
    // which will throw, however, we expect that the provided parameters cannot be
    // null or undefined.
    if (typeof value !== "string") {
        value = value.toString();
    }

    let result = "";
    for (const char of value)
    {
        let point = char.charCodeAt(0);
        if ((point >= 0x30 && point <= 0x39) || (point >= 0x41 && point <= 0x5A) || (point >= 0x61 && point <= 0x7A)) {
            // A-Z, a-z
            result += char;
        } else if (VALID_PUNCTUATION.has(char)) {
            result += char;
        } else {
            // other punctuation: hex-encode
            result += `%${point.toString(16).toUpperCase()}`;
        }
    }

    return result;
}

export type Params = { [_: string]: any };
export type ParamBuilder = (_: Params) => string;

export function paramBuilder(params: Params): string {
    const entries = Object.entries(params).filter(([_, value]) => value !== undefined && value !== null);
    var ret = "";

    if (entries.length === 0) {
        return ret;
    }

    ret = entries.map(([key, value]) => {
        if (value instanceof Array) {
            return value.map((val: any) => `${encode(key)}=${encode(val)}`).join("&");
        } else {
            return `${encode(key)}=${(encode(value))}`
        }
    }).join("&");

    return `?${ret}`;
}
